import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { RootState, useAppDispatch } from '../../../../redux/store/store'
import { useSelector } from 'react-redux'
import { GetProductsImagesThunk } from '../../../../redux/slices/components/ProductsImages/ProductsImagesSlice'
import SliderProductImage from '../../../../components/VerifyProductsImages/SliderProductImage/SliderProductImage'
import ScrollProductsImages from '../../../../components/VerifyProductsImages/ScrollProductsImages/ScrollProductsImages'

const VerifyProductsImagesScreen = () => {
    
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    const products = useSelector((state: RootState) => state.productsImages.productsImages)

    useEffect(() => {
        
        dispatch( GetProductsImagesThunk() )

        return () => {
        
        }
    }, [])
    

    return (
        <div className="width-100 height-100">
            <p className="title-screen">{t("General:label_290")}</p>
            <div className="flex mt-20 height-100">
                <SliderProductImage sliderData={products} />
                <ScrollProductsImages sliderData={products} />
            </div>
        </div>
    )
}

export default VerifyProductsImagesScreen